function positionAtBottom(toolbar, inner) {
    inner.style.position = 'relative';
    toolbar.style.position = 'absolute';
    toolbar.style.boxSizing = 'border-box';
    toolbar.style.left = '0px';
    toolbar.style.right = '0px';
    toolbar.style.top = `calc(100% - ${toolbar.offsetHeight}px)`;
    toolbar.style.zIndex = '100';
}

function positionAtTopOfEditor(toolbar, content) {
    content.style.paddingTop = '0px';
    toolbar.style.position = 'relative';
    toolbar.style.boxSizing = 'border-box';
    toolbar.style.left = '0px';
    toolbar.style.right = '0px';
    toolbar.style.top = '0px';
    toolbar.style.width = '100%';
    toolbar.style.zIndex = '100';
}

function positionAtTopOfVisibleEditorArea(toolbar, content, upperBound) {
    content.style.paddingTop = `${toolbar.offsetHeight}px`;
    toolbar.style.position = 'fixed';
    toolbar.style.boxSizing = 'border-box';
    toolbar.style.left = `${content.getBoundingClientRect().left}px`;
    toolbar.style.right = '0px';
    toolbar.style.top = `${upperBound}px`;
    toolbar.style.width = `${content.offsetWidth}px`;
    toolbar.style.zIndex = '100';
}

function placeToolbar(instance, reset) {
    const rootElement = instance.container.$;
    const header = document.getElementById('header');
    const content = rootElement.getElementsByClassName('cke_contents').item(0);
    const toolbar = rootElement.getElementsByClassName('cke_top').item(0);
    const inner = rootElement.getElementsByClassName('cke_inner').item(0);

    // Make sure we have all the expected elements, in case this gets called after the instance is destroyed.
    if (!content || !toolbar || !rootElement || !inner) {
        return;
    }

    const upperBound = header ? header.offsetHeight : 0;
    const editorTop = rootElement.getBoundingClientRect().top;
    const editorBottom = rootElement.getBoundingClientRect().bottom;

    if (reset) {
        positionAtTopOfEditor(toolbar, content);
    } else if (editorBottom <= (upperBound + toolbar.offsetHeight) && editorBottom > 0) {
        // Editor bottom is less than a toolbar's height from the top
        positionAtBottom(toolbar, inner);
    } else if (editorTop < upperBound && editorBottom > upperBound) {
        // Editor is partially scrolled up out of view.
        positionAtTopOfVisibleEditorArea(toolbar, content, upperBound);
    } else {
        // By default the toolbar is relatively positioned at the top of the editor.
        positionAtTopOfEditor(toolbar, content);
    }
}

function getPositioner(instance, editorTracker) {
    return () => {
        try {
            if (instance === editorTracker.activeInstance) {
                placeToolbar(instance);
            }
        } catch (error) {
            // Just error silently. We can live with an un-positioned toolbar.
        }
    };
}

function initFixedPosition(instance, editorTracker) {
    const positioner = getPositioner(instance, editorTracker);

    instance.on('blur', () => {
        placeToolbar(instance, true);
    });

    instance.on('contentDom', () => {
        window.addEventListener('scroll', positioner, false);
    });

    instance.on('contentDomUnload', () => {
        window.removeEventListener('scroll', positioner, false);
    });
}

function registerFixedPositionPlugin(CKEDITOR, instanceName, editorTracker) {
    const plugin = CKEDITOR.plugins.get('fixed');
    const instance = CKEDITOR.instances[instanceName];

    if (!plugin) {
        CKEDITOR.plugins.add('fixed', {
            icons: '',
            init: () => { initFixedPosition(instance, editorTracker); },
        });
    } else {
        // if the plugin has been loaded before, just update the init function to get the correct triggerFunction instance
        plugin.init = () => { initFixedPosition(instance, editorTracker); };
    }
}

export default registerFixedPositionPlugin;
